/**
 * Global Variables
 */

export const MPCVars = {
    CURRENT_YEAR: new Date().getFullYear()
};

